import { render } from "./questionDialog.vue?vue&type=template&id=67d06546&scoped=true"
import script from "./questionDialog.vue?vue&type=script&lang=js"
export * from "./questionDialog.vue?vue&type=script&lang=js"

import "./questionDialog.vue?vue&type=style&index=0&id=67d06546&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d06546"]])

export default __exports__